import type { Claims } from './types';

/** A string claim from an ID token payload, or `undefined` when absent or not a string. */
export const stringClaim = (claims: Claims, claim: string) => {
  const value = claims[claim];
  return typeof value === 'string' ? value : undefined;
};

/** A number claim from an ID token payload, or `undefined` when absent or not a number. */
export const numberClaim = (claims: Claims, claim: string) => {
  const value = claims[claim];
  return typeof value === 'number' ? value : undefined;
};
